define("shared/components/shared/plan-recommendation/index", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/object", "@ember/runloop", "@ember/service", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "shared/utils/plan-rec-analytics", "shared/utils/plan-score", "shared/utils/plan-score/tables", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _object, _runloop, _service, _component2, _tracking, _emberConcurrency, _planRecAnalytics, _planScore, _tables, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = _exports.PLAN_RECOMMENDATION_ANSWERS_KEY = _exports.AUTO_ADVANCE_DELAY = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/runloop",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"shared/utils/plan-rec-analytics",0,"shared/utils/plan-score",0,"shared/utils/plan-score/tables",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: Shared::Wizard has no Glint signature }}
  {{! No backdrop: a stray click outside the card should not dismiss a walk the user only sees once. }}
  <Shared::Wizard
    @backdrop={{false}}
    @closable={{true}}
    @focusTrap={{true}}
    @onClose={{this.dismiss}}
    @onFinish={{this.dismiss}}
    as |wizard|
  >
    <wizard.slide @id={{0}} @primaryClass="o--modalCard--narrow cPR--card" as |slide|>
      <slide.body>
        <div class="cPR--card__head">
          <Shared::PlanRecommendation::ProgressBar @current={{1}} />
          <slide.nextButton
            @buttonClass="cPR--skip qa--planRecommendation_skip"
            @dataTestIdOption="skip"
            @onClick={{fn this.skip "role"}}
            @text={{t "account.plan_recommendation.skip"}}
          />
        </div>
        <Shared::PlanRecommendation::Steps::Role
          @onSelect={{fn this.selectRole slide.nextSlide}}
          @selected={{this.role}}
        />
      </slide.body>
    </wizard.slide>
  
    <wizard.slide @id={{1}} @primaryClass="o--modalCard--narrow cPR--card" as |slide|>
      <slide.body>
        <div class="cPR--card__head">
          <Shared::PlanRecommendation::ProgressBar @current={{2}} />
          <slide.nextButton
            @buttonClass="cPR--skip qa--planRecommendation_skip"
            @dataTestIdOption="skip"
            @onClick={{fn this.skip "profiles"}}
            @text={{t "account.plan_recommendation.skip"}}
          />
        </div>
        <Shared::PlanRecommendation::Steps::Profiles
          @onSelect={{fn this.selectProfiles slide.nextSlide}}
          @selected={{this.profiles}}
        />
      </slide.body>
      <slide.footer>
        <span data-test-id="plan-recommendation-back">
          <slide.previousButton
            @buttonClass="cPR--back"
            @onClick={{fn this.back "role"}}
            @text={{t "account.plan_recommendation.back"}}
          />
        </span>
      </slide.footer>
    </wizard.slide>
  
    <wizard.slide @id={{2}} @primaryClass="o--modalCard--narrow cPR--card" as |slide|>
      <slide.body>
        <div class="cPR--card__head">
          <Shared::PlanRecommendation::ProgressBar @current={{3}} />
          <slide.nextButton
            @buttonClass="cPR--skip qa--planRecommendation_skip"
            @dataTestIdOption="skip"
            @onClick={{fn this.skip "goal"}}
            @text={{t "account.plan_recommendation.skip"}}
          />
        </div>
        <Shared::PlanRecommendation::Steps::Goal @onSelect={{this.selectGoal}} @selected={{this.goal}} />
      </slide.body>
      <slide.footer>
        <span data-test-id="plan-recommendation-back">
          <slide.previousButton
            @buttonClass="cPR--back"
            @onClick={{fn this.back "profiles"}}
            @text={{t "account.plan_recommendation.back"}}
          />
        </span>
        <slide.nextButton
          @buttonClass="o--btn o--btn--primary cPR--finish"
          @dataTestIdOption="advance"
          @isDisabled={{not this.goal}}
          @onClick={{fn this.advance "goal"}}
          @text={{t "account.plan_recommendation.finish"}}
        />
      </slide.footer>
    </wizard.slide>
  
    {{! No next button on this slide: the wizard's _navigate walks past the end of its slides array and throws. }}
    <wizard.slide @id={{3}} @primaryClass="o--modalCard--narrow cPR--card cPR--card--wide" as |slide|>
      <slide.body>
        <Shared::PlanRecommendation::Recommendation @answers={{this.answers}} @onCheckoutClose={{@onCheckoutClose}} />
      </slide.body>
    </wizard.slide>
  </Shared::Wizard>
  */
  {
    "id": "bm1JykWb",
    "block": "[[[8,[39,0],null,[[\"@backdrop\",\"@closable\",\"@focusTrap\",\"@onClose\",\"@onFinish\"],[false,true,true,[30,0,[\"dismiss\"]],[30,0,[\"dismiss\"]]]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,1,[\"slide\"]],null,[[\"@id\",\"@primaryClass\"],[0,\"o--modalCard--narrow cPR--card\"]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,2,[\"body\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[10,0],[14,0,\"cPR--card__head\"],[12],[1,\"\\n        \"],[8,[39,1],null,[[\"@current\"],[1]],null],[1,\"\\n        \"],[8,[30,2,[\"nextButton\"]],null,[[\"@buttonClass\",\"@dataTestIdOption\",\"@onClick\",\"@text\"],[\"cPR--skip qa--planRecommendation_skip\",\"skip\",[28,[37,2],[[30,0,[\"skip\"]],\"role\"],null],[28,[37,3],[\"account.plan_recommendation.skip\"],null]]],null],[1,\"\\n      \"],[13],[1,\"\\n      \"],[8,[39,4],null,[[\"@onSelect\",\"@selected\"],[[28,[37,2],[[30,0,[\"selectRole\"]],[30,2,[\"nextSlide\"]]],null],[30,0,[\"role\"]]]],null],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[2]]]]],[1,\"\\n\\n  \"],[8,[30,1,[\"slide\"]],null,[[\"@id\",\"@primaryClass\"],[1,\"o--modalCard--narrow cPR--card\"]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,3,[\"body\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[10,0],[14,0,\"cPR--card__head\"],[12],[1,\"\\n        \"],[8,[39,1],null,[[\"@current\"],[2]],null],[1,\"\\n        \"],[8,[30,3,[\"nextButton\"]],null,[[\"@buttonClass\",\"@dataTestIdOption\",\"@onClick\",\"@text\"],[\"cPR--skip qa--planRecommendation_skip\",\"skip\",[28,[37,2],[[30,0,[\"skip\"]],\"profiles\"],null],[28,[37,3],[\"account.plan_recommendation.skip\"],null]]],null],[1,\"\\n      \"],[13],[1,\"\\n      \"],[8,[39,5],null,[[\"@onSelect\",\"@selected\"],[[28,[37,2],[[30,0,[\"selectProfiles\"]],[30,3,[\"nextSlide\"]]],null],[30,0,[\"profiles\"]]]],null],[1,\"\\n    \"]],[]]]]],[1,\"\\n    \"],[8,[30,3,[\"footer\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[10,1],[14,\"data-test-id\",\"plan-recommendation-back\"],[12],[1,\"\\n        \"],[8,[30,3,[\"previousButton\"]],null,[[\"@buttonClass\",\"@onClick\",\"@text\"],[\"cPR--back\",[28,[37,2],[[30,0,[\"back\"]],\"role\"],null],[28,[37,3],[\"account.plan_recommendation.back\"],null]]],null],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[3]]]]],[1,\"\\n\\n  \"],[8,[30,1,[\"slide\"]],null,[[\"@id\",\"@primaryClass\"],[2,\"o--modalCard--narrow cPR--card\"]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,4,[\"body\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[10,0],[14,0,\"cPR--card__head\"],[12],[1,\"\\n        \"],[8,[39,1],null,[[\"@current\"],[3]],null],[1,\"\\n        \"],[8,[30,4,[\"nextButton\"]],null,[[\"@buttonClass\",\"@dataTestIdOption\",\"@onClick\",\"@text\"],[\"cPR--skip qa--planRecommendation_skip\",\"skip\",[28,[37,2],[[30,0,[\"skip\"]],\"goal\"],null],[28,[37,3],[\"account.plan_recommendation.skip\"],null]]],null],[1,\"\\n      \"],[13],[1,\"\\n      \"],[8,[39,6],null,[[\"@onSelect\",\"@selected\"],[[30,0,[\"selectGoal\"]],[30,0,[\"goal\"]]]],null],[1,\"\\n    \"]],[]]]]],[1,\"\\n    \"],[8,[30,4,[\"footer\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[10,1],[14,\"data-test-id\",\"plan-recommendation-back\"],[12],[1,\"\\n        \"],[8,[30,4,[\"previousButton\"]],null,[[\"@buttonClass\",\"@onClick\",\"@text\"],[\"cPR--back\",[28,[37,2],[[30,0,[\"back\"]],\"profiles\"],null],[28,[37,3],[\"account.plan_recommendation.back\"],null]]],null],[1,\"\\n      \"],[13],[1,\"\\n      \"],[8,[30,4,[\"nextButton\"]],null,[[\"@buttonClass\",\"@dataTestIdOption\",\"@isDisabled\",\"@onClick\",\"@text\"],[\"o--btn o--btn--primary cPR--finish\",\"advance\",[28,[37,7],[[30,0,[\"goal\"]]],null],[28,[37,2],[[30,0,[\"advance\"]],\"goal\"],null],[28,[37,3],[\"account.plan_recommendation.finish\"],null]]],null],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[4]]]]],[1,\"\\n\\n\"],[1,\"  \"],[8,[30,1,[\"slide\"]],null,[[\"@id\",\"@primaryClass\"],[3,\"o--modalCard--narrow cPR--card cPR--card--wide\"]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,5,[\"body\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[8,[39,8],null,[[\"@answers\",\"@onCheckoutClose\"],[[30,0,[\"answers\"]],[30,6]]],null],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[5]]]]],[1,\"\\n\"]],[1]]]]]],[\"wizard\",\"slide\",\"slide\",\"slide\",\"slide\",\"@onCheckoutClose\"],false,[\"shared/wizard\",\"shared/plan-recommendation/progress-bar\",\"fn\",\"t\",\"shared/plan-recommendation/steps/role\",\"shared/plan-recommendation/steps/profiles\",\"shared/plan-recommendation/steps/goal\",\"not\",\"shared/plan-recommendation/recommendation\"]]",
    "moduleName": "shared/components/shared/plan-recommendation/index.hbs",
    "isStrictMode": false
  });
  /** Answers so far, so a refresh mid-walk resumes with them instead of restarting empty. */
  const PLAN_RECOMMENDATION_ANSWERS_KEY = _exports.PLAN_RECOMMENDATION_ANSWERS_KEY = 'planRecommendation.answers';

  /** The design holds the selected state before the next question slides in (Figma 33750-33890). */
  const AUTO_ADVANCE_DELAY = _exports.AUTO_ADVANCE_DELAY = 400;
  const NEXT_STEP = {
    role: _planRecAnalytics.QUESTION_PROPERTY.profiles,
    profiles: _planRecAnalytics.QUESTION_PROPERTY.goal,
    goal: 'recommendation'
  };

  /** What localStorage may hand back: the key is ours, but the values are not trusted until checked. */

  function member(table, value) {
    return typeof value === 'string' && Object.prototype.hasOwnProperty.call(table, value) ? value : undefined;
  }
  /**
   * The walk itself; whether it shows is `<Shared::PreBoarding />`'s decision, like its sibling modals.
   */
  let PlanRecommendationComponent = _exports.default = (_class = class PlanRecommendationComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "errors", _descriptor2, this);
      _initializerDefineProperty(this, "localStorageManager", _descriptor3, this);
      _initializerDefineProperty(this, "segment", _descriptor4, this);
      /**
       * True once an outcome is on the account, whether this mount wrote it or an earlier one did. Set
       * when the write is issued, not when it resolves, so nothing later can overwrite it.
       */
      _defineProperty(this, "hasPersistedOutcome", void 0);
      /**
       * Where the user is, for the dismissal event. The wizard's close hook reports nothing and yields
       * its slide index only to slides, so the walk follows its own Next, Skip and Back clicks.
       */
      _defineProperty(this, "step", _planRecAnalytics.QUESTION_PROPERTY.role);
      _initializerDefineProperty(this, "role", _descriptor5, this);
      _initializerDefineProperty(this, "profiles", _descriptor6, this);
      _initializerDefineProperty(this, "goal", _descriptor7, this);
      _defineProperty(this, "pendingAdvance", void 0);
      /**
       * The answers, plus the outcome once the card is reached. The user clicked Next or Close, not
       * Save, and the card scores client-side, so a rejection is logged rather than shown. The local
       * copy goes only once the outcome is stored; a flush leaves it for a resume.
       */
      _defineProperty(this, "writeToAccount", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (outcome) {
          const account = this.auth.currentAccount;
          account.setProperties({
            planRecommendationRole: this.role,
            planRecommendationProfiles: this.profiles,
            planRecommendationGoal: this.goal,
            ...(outcome && {
              planRecommendationTier: outcome.tier,
              planRecommendationWinningTerm: outcome.winningTerm
            })
          });
          const isSaved = yield account.save().then(() => true, error => {
            this.errors.log(error, {
              source: 'plan recommendation account write'
            });
            return false;
          });
          if (isSaved && outcome) {
            this.localStorageManager.removeItem(PLAN_RECOMMENDATION_ANSWERS_KEY);
          }
        }
      }), {
        drop: true
      }, "writeToAccount", null));
      _defineProperty(this, "reported", {});
      this.hasPersistedOutcome = Boolean(this.auth.currentAccount.planRecommendationTier);
      const saved = this.localStorageManager.getItem(PLAN_RECOMMENDATION_ANSWERS_KEY);
      this.role = member(_tables.ROLE_FLOOR, saved?.role);
      this.profiles = member(_tables.PROFILE_POINTS, saved?.profiles);
      this.goal = member(_tables.GOAL_ANSWERS, saved?.goal);
    }
    get hasAnswers() {
      return Object.keys(this.answers).length > 0;
    }

    /** Skipped questions are omitted, not sentinel-valued: the scoring module reads a missing key as skipped. */
    get answers() {
      const answers = {};
      if (this.role) {
        answers.role = this.role;
      }
      if (this.profiles) {
        answers.profiles = this.profiles;
      }
      if (this.goal) {
        answers.goal = this.goal;
      }
      return answers;
    }

    /** A keyboard choice only selects: arrowing through the options must not change the question underfoot (WCAG 3.2.2). */
    selectRole(nextSlide, role, isPointer) {
      this.role = role;
      this.persistLocally();
      if (isPointer) {
        this.scheduleAdvance('role', nextSlide);
      }
    }
    selectProfiles(nextSlide, profiles, isPointer) {
      this.profiles = profiles;
      this.persistLocally();
      if (isPointer) {
        this.scheduleAdvance('profiles', nextSlide);
      }
    }
    selectGoal(goal) {
      this.goal = goal;
      this.persistLocally();
    }

    /**
     * Answers are reported on advance, not on select, so a changed mind before Next emits nothing.
     * Next is gated until the question is answered, so the value is always present.
     */
    advance(question) {
      this.trackAnswered(question);
      this.moveTo(NEXT_STEP[question]);
    }

    /** A kept answer is reported here because a restored one never passes through `advance`. */
    skip(question) {
      this.cancelPendingAdvance();
      if (this.answers[question]) {
        this.trackAnswered(question);
      } else {
        this.trackSkipped(question);
      }
      this.moveTo(NEXT_STEP[question]);
    }
    back(question) {
      this.cancelPendingAdvance();
      this.step = _planRecAnalytics.QUESTION_PROPERTY[question];
    }

    /** A second choice inside the hold restarts it, so the question advances once, with the last answer. */
    scheduleAdvance(question, nextSlide) {
      this.cancelPendingAdvance();
      this.pendingAdvance = (0, _runloop.later)(() => {
        this.pendingAdvance = undefined;
        this.advance(question);
        nextSlide();
      }, AUTO_ADVANCE_DELAY);
    }
    cancelPendingAdvance() {
      if (this.pendingAdvance) {
        (0, _runloop.cancel)(this.pendingAdvance);
        this.pendingAdvance = undefined;
      }
    }
    willDestroy() {
      super.willDestroy();
      this.cancelPendingAdvance();
    }
    moveTo(step) {
      this.step = step;
      if (step === 'recommendation') {
        this.reachRecommendation();
      }
    }

    /**
     * One account write, carrying answers and outcome together, the moment the card is reached. Not
     * awaited: the slide change and a failed save are independent, since the card scores client-side.
     * Written once — a remount that reaches the card again does not rewrite; the stored tier is the first shown.
     * The shown event rides on the same guard, so the tier it reports is the tier the account row holds.
     */
    reachRecommendation() {
      if (this.hasPersistedOutcome) {
        return;
      }
      this.hasPersistedOutcome = true;
      const recommendation = (0, _planScore.recommendPlan)(this.answers);
      this.segment.track(_planRecAnalytics.PLAN_REC_EVENTS.shown, (0, _planRecAnalytics.buildRecommendationPayload)(recommendation, this.answers));
      this.writeToAccount.perform(recommendation);
    }

    /**
     * Leaving before the card records the answers given so far, so an abandoned walk is still
     * distinguishable from a skipped one server-side. Never after the outcome write: the answers alone
     * would overwrite the tier. With nothing answered there is nothing to record: the dismissal path in
     * `<Shared::PreBoarding />` still writes the seen-onboarding-trial-modal state.
     */
    dismiss() {
      this.cancelPendingAdvance();
      if (!this.hasPersistedOutcome && this.hasAnswers) {
        this.writeToAccount.perform();
      }
      this.segment.track(_planRecAnalytics.PLAN_REC_EVENTS.dismissed, this.dismissalPayload);
      this.args.onDismiss();
    }

    /** On the card, the same scoring the card did, so the tier reported is the tier that was shown. */
    get dismissalPayload() {
      if (this.step !== 'recommendation') {
        return {
          step: this.step
        };
      }
      return {
        step: this.step,
        ...(0, _planRecAnalytics.buildRecommendationPayload)((0, _planScore.recommendPlan)(this.answers), this.answers)
      };
    }
    /** The service swallows unsupported or throwing storage, so the walk carries on in memory. */
    persistLocally() {
      if (this.hasPersistedOutcome) {
        return;
      }
      this.localStorageManager.setItem(PLAN_RECOMMENDATION_ANSWERS_KEY, {
        ...this.answers
      });
    }
    /** Silent once the account holds an outcome: a re-walk after a refresh must not count again. */
    trackAnswered(question) {
      const value = this.answers[question];
      if (value && !this.hasPersistedOutcome && this.reported[question] !== value) {
        this.reported[question] = value;
        // TS cannot pair a union key with that key's value type; the builder is where the shape is checked.
        this.segment.track(_planRecAnalytics.PLAN_REC_EVENTS.answered, (0, _planRecAnalytics.answerProperties)({
          [question]: value
        }));
      }
    }
    trackSkipped(question) {
      delete this.reported[question];
      if (!this.hasPersistedOutcome) {
        this.segment.track(_planRecAnalytics.PLAN_REC_EVENTS.skipped, {
          question: _planRecAnalytics.QUESTION_PROPERTY[question]
        });
      }
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "localStorageManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "role", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "profiles", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "goal", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "selectRole", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "selectRole"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectProfiles", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "selectProfiles"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectGoal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "selectGoal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "advance", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "advance"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "skip", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "skip"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "back", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "back"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dismiss", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "dismiss"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, PlanRecommendationComponent);
});